(() => {
  const root = document.querySelector('[data-combi-bundles]');
  if (!root) return;
  const zh = root.dataset.lang === 'zh';
  const t = (en, cn) => zh ? cn : en;
  const base = window.Shopify?.routes?.root || '/';
  const cache = new Map();
  function product(handle) {
    if (!cache.has(handle)) cache.set(handle, fetch(base + 'products/' + encodeURIComponent(handle) + '.js').then(r => { if (!r.ok) throw Error('product'); return r.json(); }));
    return cache.get(handle);
  }
  root.querySelectorAll('[data-bundle]').forEach(async card => {
    const button = card.querySelector('[data-add-bundle]');
    const status = card.querySelector('[data-bundle-status]');
    const items = [...card.querySelectorAll('[data-component]')].map(el => ({handle: el.dataset.handle, id: Number(el.dataset.variant), quantity: 1}));
    try {
      const products = await Promise.all(items.map(i => product(i.handle)));
      const variants = products.map((p, n) => p.variants.find(v => v.id === items[n].id));
      if (variants.some(v => !v)) throw Error('variant');
      const currency = window.Shopify?.currency?.active || 'HKD';
      card.querySelector('[data-total]').textContent = new Intl.NumberFormat(zh ? 'zh-HK' : 'en-HK', {style:'currency',currency,currencyDisplay:'code'}).format(variants.reduce((sum,v) => sum + v.price, 0) / 100);
      if (variants.some(v => !v.available)) {
        button.textContent = t('Set unavailable', '套裝暫不可購買');
        status.textContent = t('One or more items are unavailable. Use the item links to see alternatives.', '部分商品暫不可購買，請查看商品連結或選購其他組合。');
        return;
      }
      button.disabled = false;
      button.textContent = t('Add complete set to cart', '整套加入購物車');
    } catch (_) {
      button.textContent = t('Unable to load set', '暫時無法載入套裝');
      status.textContent = t('Refresh to retry, or use the product links to shop individually.', '請重新整理，或使用商品連結分開選購。');
      return;
    }
    button.addEventListener('click', async () => {
      button.disabled = true;
      status.textContent = t('Adding your set…', '正在加入套裝…');
      try {
        const response = await fetch(base + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(({id,quantity})=>({id,quantity}))})});
        const result = await response.json();
        if (!response.ok) throw Error(result.description || result.message || 'cart');
        // Navigate to Shopify's cart so line items and the header count render from authoritative cart state.
        window.location.assign(base + 'cart');
      } catch (_) {
        status.textContent = t('We could not confirm the full set was added. Check your cart before retrying; availability may have changed.', '未能確認整套已加入。庫存可能有變，請先查看購物車再重試。');
        card.querySelector('[data-bundle-cart]').hidden = false;
        button.disabled = false;
      }
    });
  });
})();
